import { logger } from 'lib/slardar-utils'
import cookie from 'cookie'

// 快速 获取 用户信息
const getUserInfo = (req?: any) => {
  try {
    return JSON.parse(
      cookie.parse(req?.headers?.cookie || window?.document?.cookie)[
        'user_data'
      ]
    )
  } catch (error) {
    logger.warn('[get user info]:failed to parse cookie', error?.message)
    return {}
  }
}

export default getUserInfo
